import { PaymentMethodEnum } from '@config/enum/distributor.enum';

export enum EnumCardVerificationForm {
  DEFAULT = 'default',
  KTP = 'ktp',
  GROUP = 'group',
  DOCUMENT = 'document',
  UPDATE_DOCUMENT = 'update_document',
  MODAL_MAP = 'modal_map',
  ASIDE_DOCUMENT = 'aside_document',
}

export enum EnumTypeBodyCardVerificationForm {
  IMG_URL = 'img_url',
  CURRENCY = 'currency',
  DATE = 'date',
  DATE_FORMAT = 'date_format',
  SPACE_MEASURE = 'space_measure',
}

export enum EnumCardVerificationSection {
  SCOPE = 'SCOPE',
  DISTRIBUTOR_DETAIL = 'DISTRIBUTOR_DETAIL',
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
  BUSINESS_BRANCH = 'BUSINESS_BRANCH',
  BUSINESS_INFORMATION = 'BUSINESS_INFORMATION',
  SUPPLIER_INFORMATION = 'SUPPLIER_INFORMATION',
  CREDIT_CEILING_GRANTED = 'CREDIT_CEILING_GRANTED',
  SALE_TARGET = 'SALE_TARGET',
  CREDIT_BILLING = 'CREDIT_BILLING',
  DELIVERY_ADDRESS = 'DELIVERY_ADDRESS',
  NPWP_INFORMATION = 'NPWP_INFORMATION',
  NPWP_DOCUMENT = 'NPWP_DOCUMENT',
  DOCUMENT = 'DOCUMENT',
  DOCUMENT_UPDATE_DISTRIBUTOR = 'DOCUMENT_UPDATE_DISTRIBUTOR',
  DOCUMENT_VERIFY_KUL = 'DOCUMENT_VERIFY_KUL',
}

export enum EnumViewCardVerificationSection {
  SCOPE = 'cakupan',
  DISTRIBUTOR_DETAIL = 'detail distributor',
  OWNER = 'pemilik usaha',
  MANAGER = 'pengelola usaha',
  BUSINESS_BRANCH = 'cabang usaha',
  BUSINESS_INFORMATION = 'informasi usaha',
  SUPPLIER_INFORMATION = 'informasi supplier',
  CREDIT_CEILING_GRANTED = 'plafon diberikan',
  SALE_TARGET = 'target penjualan',
  CREDIT_BILLING = 'penagihan kredit',
  DELIVERY_ADDRESS = 'delivery_address',
  DOCUMENT = 'document',
  DOCUMENT_UPDATE_DISTRIBUTOR = 'dokumen pembaruan data',
  DOCUMENT_VERIFY_KUL = 'dokumen verifikasi',
}

// Map styles moved to GoogleMapsConfigService for centralized management
// This export is deprecated - use GoogleMapsConfigService.getMapStyles() instead
export const mapStyles = [];

// Distributor Data
export const scopeBodyData = [
  { label: 'Area', key: 'area_name' },
  { label: 'Sub Area', key: 'sub_area_name' },
  { label: 'Regional Head', key: 'regional_head_name' },
  { label: 'No. Telephone', key: 'regional_head_phone' },
  { label: 'Marketing Executive', key: 'marketing_executive_name' },
  { label: 'No. Telephone', key: 'marketing_executive_phone' },
];

export const distributorDetailBodyData = [
  { label: 'Nama Usaha', key: 'name' },
  { label: 'Tipe Distributor', key: 'type' },
  { label: 'No Telephone', key: 'phone' },
  { label: 'Email', key: 'email' },
  { label: 'Alamat Usaha', key: 'address' },
  { label: '', key: 'map' },
];

export const ownerBodyData = [
  { label: 'Nama', key: 'name' },
  { label: 'NIK', key: 'nik' },
  { label: 'No Telephone', key: 'phone' },
  { label: 'Email', key: 'email' },
  { label: 'Alamat', key: 'address' },
  { label: 'KTP Pemilik Usaha', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'ktp_url' },
];

export const managerBodyData = [
  { label: 'Nama', key: 'name' },
  { label: 'NIK', key: 'nik' },
  { label: 'No Telephone', key: 'phone' },
  { label: 'No Whatsapp', key: 'whatsapp' },
  { label: 'Email', key: 'email' },
  { label: 'Alamat', key: 'address' },
  { label: 'KTP Pengelola Usaha', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'ktp_url' },
];

export const npwpBodyData = [
  { label: 'Nomor NPWP', key: 'number' },
  { label: 'Nama Sesuai NPWP', key: 'name' },
  { label: 'Alamat Sesuai NPWP', key: 'address' },
  { label: 'Informasi PKP', key: 'pkp_information' },
];

export const npwpInfoBodyData = [
  ...npwpBodyData,
  { label: 'NPWP', key: 'npwp_document_url', type: EnumTypeBodyCardVerificationForm.IMG_URL },
  {
    label: 'Surat Pernyataan non PKP',
    key: 'non_pkp_document_url',
    type: EnumTypeBodyCardVerificationForm.IMG_URL,
  },
];

export const branchBodyData = [
  { label: 'Label Usaha', key: 'name' },
  { label: 'Alamat Lengkap', key: 'address' },
];

// Business Data
export const businessBodyData = (keyDocument = 'deed_incorporation_url') => {
  return [
    { label: 'Tanggal Pendirian Usaha', type: EnumTypeBodyCardVerificationForm.DATE_FORMAT, key: 'established_date' },
    { label: 'Kegiatan Usaha', key: 'business_activity' },
    { label: 'Jenis Barang Dijual', key: 'selling_item' },
    { label: 'Luas Usaha/Toko', key: 'space_large' },
    { label: 'Jumlah Karyawan', key: 'employee_qty' },
    { label: 'Sistem Pembayaran', key: 'payment_method' },
    { label: 'Omzet Per Tahun', type: EnumTypeBodyCardVerificationForm.CURRENCY, key: 'turnover_per_year' },
    { label: 'Akta Pendirian', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: keyDocument },
  ];
};

export const supplierBodyData = (currentValue: any, revisionValue?: any) => {
  const data = [
    { label: 'Nama Perusahaan', key: 'name' },
    { label: 'Jenis Barang Dijual', key: 'selling_item' },
    { label: 'Fasilitas yang Disediakan', key: 'facility' },
    { label: 'Sistem Pembayaran', key: 'payment_method_string' },
  ];

  // CASH_CREDIT, CREDIT, CASH
  const paymentMethod = revisionValue ? revisionValue.payment_method_enum : currentValue.payment_method_enum;
  if (paymentMethod !== PaymentMethodEnum.CASH) {
    data.push({ label: 'Jangka waktu Kredit', key: 'credit_term' });
  }
  return data;
};

// Credit Ceiling
export const creditCeilingBodyData = (currentValue: any, revisionValue?: any) => {
  const data = [{ label: 'Tipe Pembayaran', key: 'payment_method_string' }];
  const paymentMethod = revisionValue?.payment_method_enum ? revisionValue.payment_method_enum : currentValue.payment_method_enum;
  if (paymentMethod === PaymentMethodEnum.CREDIT_CEILING) {
    const _data = [
      { label: 'Plafon yang diberikan', type: EnumTypeBodyCardVerificationForm.CURRENCY, key: 'credit_limit' },
      { label: 'Alasan', key: 'reason' },
      { label: 'Jangka waktu Kredit', key: 'credit_term' },
      { label: 'Analisa Pembayaran', key: 'analysis' },
      { label: 'Jaminan', key: 'assurance' },
    ];
    data.push(..._data);
  }
  return data;
};

export const saleTargetBodyData = (saleTarget: any) => {
  const data: { label: string; type?: EnumTypeBodyCardVerificationForm; key: string }[] = [
    { label: 'Tahun Ke-1', type: EnumTypeBodyCardVerificationForm.CURRENCY, key: 'first_year_target' },
    { label: 'Tahun Ke-2', type: EnumTypeBodyCardVerificationForm.CURRENCY, key: 'second_year_target' },
    { label: 'Tahun Ke-3', type: EnumTypeBodyCardVerificationForm.CURRENCY, key: 'third_year_target' },
  ];
  if (saleTarget && saleTarget.fourth_year_target) {
    data.push({ label: 'Tahun Ke-4', type: EnumTypeBodyCardVerificationForm.CURRENCY, key: 'fourth_year_target' });
  }
  if (saleTarget && saleTarget.fifth_year_target) {
    data.push({ label: 'Tahun Ke-5', type: EnumTypeBodyCardVerificationForm.CURRENCY, key: 'fifth_year_target' });
  }
  if (saleTarget && saleTarget.market_share_percentage) {
    data.push({ label: 'Persentase Pangsa Pasar', key: 'market_share_percentage' });
  }
  return data;
};

export const creditBillingBodyData = (creditBilling: any) => {
  const data = [
    { label: 'Penagihan Ke', key: 'billing_to' },
    { title: 'Profil Tertagih', label: '', key: '' },
    { label: 'Nama', key: 'name' },
    { label: 'NIK', key: 'nik' },
    { label: 'Nomor Telephone', key: 'phone' },
    { label: 'Nomor Whatsapp', key: 'whatsapp' },
    { label: 'Email', key: 'email' },
    { label: 'Alamat', key: 'full_address' },
  ];
  if (creditBilling.billing_to_enum === 'OWNER') {
    data.splice(5, 1);
  }
  return data;
};

// Shipping Address
export const shippingAddressBodyData = [
  { label: 'Label Alamat', key: 'label' },
  { label: 'Nama PIC', key: 'pic_name' },
  { label: 'No Telephone PIC', key: 'pic_phone' },
  { label: 'Kota', key: 'regency_name' },
  { label: 'Kecamatan', key: 'district_name' },
  { label: 'Kelurahan', key: 'sub_district_name' },
  { label: 'Alamat Lengkap', key: 'address' },
  { label: '', key: 'map' },
];

// Document
export const documentBodyData = [
  { label: 'KTP Pemilik', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'ktp_owner_document_url' },
  { label: 'KTP Pengelola', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'ktp_manager_document_url' },
  { label: 'Akta Pendirian', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'deed_incorporation_document_url' },
  { label: 'Akta Perubahan', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'deed_amendment_document_url' },
  { label: 'NIB', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'nib_document_url' },
  { label: 'Foto Tempat Usaha', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'place_business_document_url' },
  { label: 'Dokumen Lainnya', type: EnumTypeBodyCardVerificationForm.IMG_URL, key: 'other_document_url' },
];
